//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';
    angular
        .module('container.core')
        .factory('authInterceptorService', authInterceptorService)
        .config(pushInterceptor)
    ;
    function authInterceptorService($q, $rootScope, Event) {

        let service = {
            authentication: null,
        };

        var lastTokenRefreshTriggered;
        var timePassedSinceLastRefresh = 5;

        service.request = config => {

            let d = $q.defer();

            if (lastTokenRefreshTriggered !== undefined) {
                timePassedSinceLastRefresh = ((new Date()).getTime() - lastTokenRefreshTriggered.getTime()) / 1000;
            }

            if (config.headers['skipRefresh']  != 'true' && config.url.indexOf('assets') == '-1' && timePassedSinceLastRefresh > 2) {
                lastTokenRefreshTriggered = new Date();
                window._keycloak.updateToken(300).then((refreshed)=>{
                    if (refreshed){
                        console.log('Token refreshed '+ new Date());
                        localStorage.setItem('accessTokenUpdatedBy', 'user');
                        var token = window._keycloak.token;

                        config.headers = config.headers || {};
                        config.headers['Access-Token'] = token;

                        $rootScope.$emit(Event.OC_STAT_SERVICE_RESTART);

                        d.resolve(config);
                    }else {
                        d.resolve(config);
                    }
                }).catch(() => {
                    let msg = 'Token refresh failed '+ new Date();
                    console.info(msg);
                    $rootScope.$emit(Event.USER_LOGGED_OUT);
                    d.reject(msg);
                    window._keycloak.logout();
                });
            } else {
                config.headers['Access-Token'] = window._keycloak.token;
                d.resolve(config);
            }

            
            delete config.headers['skipRefresh'];
            
            return d.promise;

        };

        const rejectionStatusLabels = {
            '450': 'InvalidSignature',
            '451': 'IncosistentUserName',
            '452': 'Expired',
            '453': 'NoUserFound',
            '454': 'NoRolesFound',
            '455': 'Empty',
            '460': 'Invalid',
            '461': 'UnknownState'
        }

        service.responseError = rejection => {
            let evt = {
                status: rejection.status,
                statusText: rejectionStatusLabels[rejection.status],
                method: rejection.config.method,
                url: rejection.config.url
            }

            console.error('Http response error.', evt);

            switch(rejection.status) {

                case 450: /*InvalidSignature*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                case 451: /*IncosistentUserName*/ {
                    break;
                }
                case 452: /*Expired*/ {
                    $rootScope.$emit(Event.USER_LOGGED_OUT);
                    break;
                }
                case 453: /*NoUserFound*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                case 454: /*NoRolesFound*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                case 455: /*Empty*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                case 460: /*Invalid*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                case 461: /*UnknownState*/ {
                    $rootScope.$emit(Event.AUTHENTICATION_ERROR, evt);
                    break;
                }
                default: {

                }

            }

            return $q.reject(rejection);
        };

        return service;
    }

    function pushInterceptor($httpProvider) {
        $httpProvider.interceptors.push('authInterceptorService');
    }
})();
